export default {
      id: "video-usage",
      viewBox: "0 0 104 92",
      url: __webpack_public_path__ + "img/icons.df848786.svg#video",
      toString: function () {
        return this.url;
      }
    }